/**
 * OpenC / 三方支付配置接口返回的 fiatIconMap（法币代码 → CDN 图标 URL）。
 * 与后端 result.data.fiatIconMap 一致时可由接口覆盖合并；此处为离线兜底。
 * @see 聚合 pair 配置响应中的 fiatIconMap
 */
export const THIRD_PARTY_FIAT_ICON_MAP = {
  CHF: "https://api.openc.pro/upload/2022/01/08/5c6a5337-6c88-4f45-a7f6-f372de86973d.svg",
  MXN: "https://api.openc.pro/upload/2022/01/08/2d848e8e-af08-4a51-aa9f-4162c7f1392f.svg",
  KZT: "https://api.openc.pro/upload/2022/01/08/cb7d3937-7f62-4c72-b269-f802ccbd599b.svg",
  ZAR: "https://api.openc.pro/upload/2022/01/08/92eb1c82-f69f-4190-8bfb-8a3272586a16.svg",
  VND: "https://api.openc.pro/upload/2022/01/08/f75db363-69a3-4a82-94bd-6a393bb95c3b.svg",
  THB: "https://api.openc.pro/upload/2022/01/08/61f8f387-fd8f-40a2-ae13-3bd64b7a61e9.svg",
  AUD: "https://api.openc.pro/upload/2022/01/08/40c3e48b-edd1-4f9e-927e-c92a2b68b968.svg",
  ILS: "https://api.openc.pro/upload/2022/01/08/b76c3d24-db8c-4eea-91ba-5bcb9434645b.svg",
  KRW: "https://api.openc.pro/upload/2022/01/08/40c75db8-0023-4d42-b250-4b93965d5856.svg",
  JPY: "https://api.openc.pro/upload/2022/01/07/9d1cfbbe-e7a9-447b-9d5c-9f97032b487e.png",
  PLN: "https://api.openc.pro/upload/2022/01/08/3b76613b-c224-4d12-9ad5-269a9e71b828.svg",
  GBP: "https://api.openc.pro/upload/2022/01/08/ba6b5e5a-2cea-40ac-95c1-0f58aa0af1b6.svg",
  IDR: "https://api.openc.pro/upload/2022/01/08/beab1459-4b7c-43e2-9960-03c4ea786d92.svg",
  HUF: "https://api.openc.pro/upload/2022/01/08/9e74f157-3d97-4f82-8840-ecbf188d9a52.svg",
  PHP: "https://api.openc.pro/upload/2022/01/08/c7a5c069-6a85-453c-96aa-f78ea76a605f.svg",
  AED: "https://api.openc.pro/upload/2022/01/08/4e84f71a-b1a4-4274-90a7-8ccf0e25c5e5.svg",
  HKD: "https://api.openc.pro/upload/2022/01/08/9ab36236-a72f-4fb3-a7a2-3a59359797b6.svg",
  TWD: "https://api.openc.pro/upload/2022/01/08/7c18d4e1-d9d5-497b-87d0-5afcb4ec36f0.svg",
  EUR: "https://api.openc.pro/upload/2022/01/08/fb0b9e05-405a-4ae0-851c-551d86b76b49.svg",
  COP: "https://api.openc.pro/upload/2022/01/08/5011885e-423f-4929-815a-457bccac4661.svg",
  DKK: "https://api.openc.pro/upload/2022/01/08/bc2bf1dd-84e7-4ee5-8bea-d28b43158f73.svg",
  CAD: "https://api.openc.pro/upload/2022/01/08/0650d4c2-43bf-4a97-95b8-72c3717d4b25.svg",
  MYR: "https://api.openc.pro/upload/2022/01/08/a6ce8050-5771-4de3-a1d9-831d533dd3bb.svg",
  USD: "https://api.openc.pro/upload/2022/01/08/af56e089-6d83-4209-ab3a-ee8cab718554.svg",
  BGN: "https://api.openc.pro/upload/2022/01/08/654a227e-c443-43e8-adfe-ff4b32070227.svg",
  NOK: "https://api.openc.pro/upload/2022/01/08/1d694d6b-bc3e-44bc-9baa-be11904e8eb1.svg",
  PAB: "https://api.openc.pro/upload/2022/01/08/5a240f63-5880-4eca-847c-43c2b2081137.svg",
  RON: "https://api.openc.pro/upload/2022/01/08/3a4414bf-d1a8-4ded-8781-b9b43fbd1ec6.svg",
  SGD: "https://api.openc.pro/upload/2022/01/08/0df26876-9295-4131-b9a1-ea1835a30016.svg",
  CRC: "https://api.openc.pro/upload/2022/01/08/473e0195-f038-48ce-8c2a-cfb80d1cf7de.svg",
  CZK: "https://api.openc.pro/upload/2022/01/08/b89380b3-d4f3-4710-8328-29d32812818f.svg",
  OMR: "https://api.openc.pro/upload/2022/02/15/901e6857-0965-46b9-9684-d92d166493f4.svg",
  KGS: "https://api.openc.pro/upload/2022/01/08/2abb7994-c890-443b-be6b-64997adeb490.svg",
  KES: "https://api.openc.pro/upload/2022/01/08/d63160cb-df95-4480-b302-8cf943760274.svg",
  PEN: "https://api.openc.pro/upload/2022/01/08/db136fcb-cacb-4f60-8e40-fbf41f180eb0.svg",
  SEK: "https://api.openc.pro/upload/2022/01/08/13e7d6ed-c8e3-4399-800e-6a72dafafc56.svg",
  BRL: "https://api.openc.pro/upload/2022/01/08/b3ceba8a-b492-4574-bb45-4fb2803c6662.svg",
};

/**
 * @param {string} code 法币代码，如 USD
 * @param {{ icon?: string, iconUrl?: string } | null} apiRow 接口单行法币数据（若含 icon 字段优先）
 * @param {Record<string, string> | null} runtimeMap 与接口同步的 fiatIconMap（覆盖静态表）
 * @returns {string}
 */
export function resolveThirdPartyFiatIconUrl(code, apiRow = null, runtimeMap = null) {
  const key = String(code || "").toUpperCase();
  const fromRow = apiRow && (apiRow.iconUrl || apiRow.icon);
  if (fromRow) return String(fromRow);
  if (runtimeMap && typeof runtimeMap === "object" && runtimeMap[key]) return runtimeMap[key];
  return THIRD_PARTY_FIAT_ICON_MAP[key] || "";
}
